import * as React from 'react'
import { ComponentExt } from '@utils/reactExt'
import * as styles from './style/index.scss'
import ModalImg from '@assets/img/global/bj_gift_box.png'
import giftInfinite from '@assets/img/global/bj_infinite.png'
import CloseImg from '@assets/img/del_bullet_box.png'
import { filterFlowUnit, formatPackageTimeLength } from '@src/utils';
import intl from '@utils/intl';
import { getLang } from '@src/utils'
import { userStore } from '@src/store/userStore'
import { TRYBUY_EVENT_TRACING_CLICK } from '@src/constants'
interface ActiveModalProps {
    dto: any
    operatorsId: any
    handleActive: () => void
}

class ActiveModal extends ComponentExt<ActiveModalProps, any> {
    constructor(props) {
        super(props)
        this.state = {
            showModal: true
        }
    }

    formatPackageContent = (dto) => {
        const { policyDegree, goodsNumber, timeLength, timeUnit } = dto
        const obj = formatPackageTimeLength({ timeLength, timeUnit })
        const oddMessageId = obj.timeUnit === '0' ? 'common.unitMonthOdd' : 'common.unitDayOdd'
        const pluralMessageId = obj.timeUnit === '0' ? 'common.unitMonthPlural' : 'common.unitDayPlural'
        const totalTimeLength = goodsNumber * obj.timeLength
        // const currentDate = new Date().getDate();
        // const currentMonth = new Date().getMonth() + 1;
        // if ((this.props.operatorsId == 6) && ((currentMonth == 11 && currentDate >= 15) || currentMonth == 12 || (currentMonth == 1 && currentDate <= 15))) {
        //     return `1GB * 6${intl.formatMessage({ id: 'common.unitMonthPlural' })}+5GB * 3${intl.formatMessage({ id: 'common.unitMonthPlural' })}`
        // } else {
        //     return `${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })}`
        // }
        if (this.props.operatorsId == 20) {
            if (getLang() === 'it') {
                return `Attiva i tuoi dati gratuiti ${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })}`
            } else {
                return `Activate your ${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })} free data `
            }
        } else {
            return `${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })}`
        }
        // return `${filterFlowUnit(Number(policyDegree))} * ${totalTimeLength}${intl.formatMessage({ id: totalTimeLength > 1 ? pluralMessageId : oddMessageId })}`

    }
    closeModal = () => {
        this.setState({ showModal: false })
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_CLOSE_ACTIVE_MODAL,
            buttonInfo: ''
        })
    }
    handleActive = () => {
        this.props.handleActive()
        userStore.sendEventTracing({
            pageCode: '',
            buttonCode: TRYBUY_EVENT_TRACING_CLICK.TRYBUY_ACTIVE_PACKAGE_BY_MODAL,
            buttonInfo: ''
        })
    }
    render() {
        if (!this.state.showModal) {
            return null
        }
        const tableApp = localStorage.getItem('chl') === 'tabletApp'
        return (
            <section className={styles.activeModalWrap}>
                <div className={styles.innerWrap}>
                    <img src={CloseImg} className={styles.closeImg} onClick={this.closeModal} />
                    <img src={tableApp ? giftInfinite : ModalImg} className={styles.innerImg} onClick={this.handleActive} />
                    {/* <img src={ModalImg} className={styles.innerImg} onClick={this.handleActive} /> */}
                    <span className={styles.activePackageInfo}>{this.formatPackageContent(this.props.dto)}</span>
                    {/* {tableApp && <span className={`${styles.activePackageInfo} ${styles.activePackage}`}>{intl.formatMessage({ id: 'common.infiniteAct' })}</span>} */}
                </div>
            </section>
        )
    }
}

export default ActiveModal
